import cleanedFilename from '~/util/cleanedFilename';

export default {
  VARIABLE_DROPDOWN: `${cleanedFilename(__filename)}-variable-dropdown`,
  FIELD_DROPDOWN: `${cleanedFilename(__filename)}-field-dropdown`,
};
